<template>
  <v-dialog v-model="show" fullscreen persistent @keydown.esc="hide">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" text :loading="loading" :disabled="disableButton">
        {{ text }}
      </v-btn>
    </template>

    <v-card>
      <v-card-title>
        <span class="title text--secondary">
          {{ title }} {{ $t("employees.title").toUpperCase() }}
        </span>
        <v-spacer />
        <v-btn icon @click="hide"><v-icon>close</v-icon></v-btn>
      </v-card-title>
      <employees-table
        :employees="employees"
        :tagCategories="tagCategories"
        :loading="loading"
        :showCounters="false"
        @refresh="$parent.$apollo.queries.employees.refresh()"
        :reason="reason"
        :versionId="versionId"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import EmployeesTable from "@/components/employee/EmployeesTable.vue";

export default {
  props: [
    "text",
    "employees",
    "tagCategories",
    "title",
    "loading",
    "disableButton",
    "reason",
    "versionId",
  ],
  components: {
    EmployeesTable,
  },
  data() {
    return {
      show: false,
    };
  },
  mounted() {},
  computed: {},
  methods: {
    hide() {
      this.show = false;
    },
  },
};
</script>
